import {GetterTree} from 'vuex'

export const getters: GetterTree<any, any> = {

    currentTenant: (state, getters, rootState, rootGetters) => {

        if (rootState.PanelSettings.settings.name && state.tenants) {
            return state.tenants.find((tenant: any) => {
                return tenant.panel_name === rootState.PanelSettings.settings.name;
            });
        }
        return null;
    },
}
